import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import VueCurrencyInput from 'vue-currency-input';
import VueFlashMessage from 'vue-flash-message';
import VueFriendlyIframe from 'vue-friendly-iframe';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import TextareaAutosize from 'vue-textarea-autosize';
Vue.use(TextareaAutosize);
 
Vue.use(TextareaAutosize)
const pluginOptions = {
  /* see config reference */
  globalOptions: { 
    currency: 'USD', 
    locale:'en-US',
    precision:2,
  }
}
Vue.use(VueFriendlyIframe);
Vue.use(require('vue-moment'));
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.component('v-select', vSelect);
Vue.use(VueFlashMessage, { messageOptions: {
  timeout: 4000,
  // important: true,
  // autoEmit: false,  
  pauseOnInteract: true
}});

Vue.use(VueAxios, axios, VueCookies);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
